import fetch from '../../fetch';

const queryCharts = (data) => {
    return fetch.post('surveystudentorganalysis/score2', data);
}

export default {
    queryCharts
}